import React from 'react'
import { useSelector } from 'react-redux'
import { VAPermissions } from 'Utils/constants'
import useValidatePermission from 'Hooks/useValidatePermission'
import CostMarginVisibility from 'Components/CostMarginVisibility/CostMarginVisibility'
import { useTotalMargin } from 'Hooks/useTotalMargin'

function MarginText() {
  const quoteLines = useSelector(state => state.cotizacion.QuoteHeader.Lines)
  const seeMargenProd = useValidatePermission(VAPermissions.seeMargenProd)
  const { totalPrice, totalCost } = useTotalMargin(quoteLines)

  return (
    <div style={{ marginTop: 10 }}>
      {seeMargenProd && (
        <CostMarginVisibility
          seeMargenProd={seeMargenProd}
          cost={totalCost}
          price={totalPrice}
          istotalMargin
          secondaryColor
        />
      )}
    </div>
  )
}

export default MarginText
